/// <reference types="vite-plugin-svgr/client" />

import styled, { css } from "styled-components";
import { ITheme } from "../Themes/ThemeTypes";
import MenuIcon from "@material-symbols/svg-400/outlined/menu.svg?react";
import MenuIconFill from "@material-symbols/svg-400/outlined/menu-fill.svg?react";
import MoreVertIcon from "@material-symbols/svg-400/outlined/more_vert.svg?react";
import MoreVertIconFill from "@material-symbols/svg-400/outlined/more_vert-fill.svg?react";
import SettingsIcon from "@material-symbols/svg-400/outlined/settings.svg?react";
import SettingsIconFill from "@material-symbols/svg-400/outlined/settings-fill.svg?react";
import PersonIcon from "@material-symbols/svg-400/outlined/person.svg?react";
import PersonIconFill from "@material-symbols/svg-400/outlined/person-fill.svg?react";
import SportsEsportsIcon from "@material-symbols/svg-400/outlined/sports_esports.svg?react";
import SportsEsportsIconFill from "@material-symbols/svg-400/outlined/sports_esports-fill.svg?react";
import AddIcon from "@material-symbols/svg-400/outlined/add.svg?react";
import AddIconFill from "@material-symbols/svg-400/outlined/add-fill.svg?react";
import AppsIcon from "@material-symbols/svg-400/outlined/apps.svg?react";
import AppsIconFill from "@material-symbols/svg-400/outlined/apps-fill.svg?react";
import ArrowBackIcon from "@material-symbols/svg-400/outlined/arrow_back.svg?react";
import ArrowBackIconFill from "@material-symbols/svg-400/outlined/arrow_back-fill.svg?react";
import HistoryIcon from "@material-symbols/svg-400/outlined/history.svg?react";
import HistoryIconFill from "@material-symbols/svg-400/outlined/history-fill.svg?react";
import SyncIcon from "@material-symbols/svg-400/outlined/sync.svg?react";
import SyncIconFill from "@material-symbols/svg-400/outlined/sync-fill.svg?react";
import PaletteIcon from "@material-symbols/svg-400/outlined/palette.svg?react";
import PaletteIconFill from "@material-symbols/svg-400/outlined/palette-fill.svg?react";
import NavigationIcon from "@material-symbols/svg-400/outlined/navigation.svg?react";
import NavigationIconFill from "@material-symbols/svg-400/outlined/navigation-fill.svg?react";
import HomeIcon from "@material-symbols/svg-400/outlined/home.svg?react";
import HomeIconFill from "@material-symbols/svg-400/outlined/home-fill.svg?react";
import DownloadIcon from "@material-symbols/svg-400/outlined/download.svg?react";
import DownloadIconFill from "@material-symbols/svg-400/outlined/download-fill.svg?react";
import UploadIcon from "@material-symbols/svg-400/outlined/upload.svg?react";
import UploadIconFill from "@material-symbols/svg-400/outlined/upload-fill.svg?react";
import FullscreenIcon from "@material-symbols/svg-400/outlined/fullscreen.svg?react";
import FullscreenIconFill from "@material-symbols/svg-400/outlined/fullscreen-fill.svg?react";
import OpenInFullIcon from "@material-symbols/svg-400/outlined/open_in_full.svg?react";
import OpenInFullIconFill from "@material-symbols/svg-400/outlined/open_in_full-fill.svg?react";
import CloseFullscreenIcon from "@material-symbols/svg-400/outlined/close_fullscreen.svg?react";
import CloseFullscreenIconFill from "@material-symbols/svg-400/outlined/close_fullscreen-fill.svg?react";
import CloseIcon from "@material-symbols/svg-400/outlined/close.svg?react";
import CloseIconFill from "@material-symbols/svg-400/outlined/close-fill.svg?react";
import CloudOffIcon from "@material-symbols/svg-400/outlined/cloud_off.svg?react";
import CloudOffIconFill from "@material-symbols/svg-400/outlined/cloud_off-fill.svg?react";
import LocalBarIcon from "@material-symbols/svg-400/outlined/local_bar.svg?react";
import LocalBarIconFill from "@material-symbols/svg-400/outlined/local_bar-fill.svg?react";
import LogoutIcon from "@material-symbols/svg-400/outlined/logout.svg?react";
import LogoutIconFill from "@material-symbols/svg-400/outlined/logout-fill.svg?react";
import RestaurantIcon from "@material-symbols/svg-400/outlined/restaurant.svg?react";
import RestaurantIconFill from "@material-symbols/svg-400/outlined/restaurant-fill.svg?react";
import SportsBarIcon from "@material-symbols/svg-400/outlined/sports_bar.svg?react";
import SportsBarIconFill from "@material-symbols/svg-400/outlined/sports_bar-fill.svg?react";
import CheckIcon from "@material-symbols/svg-400/outlined/check.svg?react";
import CheckIconFill from "@material-symbols/svg-400/outlined/check-fill.svg?react";
import ArrowForwardIcon from "@material-symbols/svg-400/outlined/arrow_forward.svg?react";
import ArrowForwardIconFill from "@material-symbols/svg-400/outlined/arrow_forward-fill.svg?react";
import ErrorIcon from "@material-symbols/svg-400/outlined/error.svg?react";
import ErrorIconFill from "@material-symbols/svg-400/outlined/error-fill.svg?react";
import WarningIcon from "@material-symbols/svg-400/outlined/warning.svg?react";
import WarningIconFill from "@material-symbols/svg-400/outlined/warning-fill.svg?react";
import WarehouseIcon from "@material-symbols/svg-400/outlined/warehouse.svg?react";
import WarehouseIconFill from "@material-symbols/svg-400/outlined/warehouse-fill.svg?react";
import PublishIcon from "@material-symbols/svg-400/outlined/publish.svg?react";
import PublishIconFill from "@material-symbols/svg-400/outlined/publish-fill.svg?react";
import BuildIcon from "@material-symbols/svg-400/outlined/build.svg?react";
import BuildIconFill from "@material-symbols/svg-400/outlined/build-fill.svg?react";
import DatabaseIcon from "@material-symbols/svg-400/outlined/database.svg?react";
import DatabaseIconFill from "@material-symbols/svg-400/outlined/database-fill.svg?react";
import GroupsIcon from "@material-symbols/svg-400/outlined/groups.svg?react";
import GroupsIconFill from "@material-symbols/svg-400/outlined/groups-fill.svg?react";
import MapIcon from "@material-symbols/svg-400/outlined/map.svg?react";
import MapIconFill from "@material-symbols/svg-400/outlined/map-fill.svg?react";
import ScheduleIcon from "@material-symbols/svg-400/outlined/schedule.svg?react";
import ScheduleIconFill from "@material-symbols/svg-400/outlined/schedule-fill.svg?react";
import PlayCircleIcon from "@material-symbols/svg-400/outlined/play_circle.svg?react";
import PlayCircleIconFill from "@material-symbols/svg-400/outlined/play_circle-fill.svg?react";
import PrintIcon from "@material-symbols/svg-400/outlined/print.svg?react";
import PrintIconFill from "@material-symbols/svg-400/outlined/print-fill.svg?react";
import CalendarMonthIcon from "@material-symbols/svg-400/outlined/calendar_month.svg?react";
import CalendarMonthIconFill from "@material-symbols/svg-400/outlined/calendar_month-fill.svg?react";
import ChevronLeftIcon from "@material-symbols/svg-400/outlined/chevron_left.svg?react";
import ChevronLeftIconFill from "@material-symbols/svg-400/outlined/chevron_left-fill.svg?react";
import ChevronRightIcon from "@material-symbols/svg-400/outlined/chevron_right.svg?react";
import ChevronRightIconFill from "@material-symbols/svg-400/outlined/chevron_right-fill.svg?react";
import ArrowDropDownIcon from "@material-symbols/svg-400/outlined/arrow_drop_down.svg?react";
import ArrowDropDownIconFill from "@material-symbols/svg-400/outlined/arrow_drop_down-fill.svg?react";
import KeyboardIcon from "@material-symbols/svg-400/outlined/keyboard.svg?react";
import KeyboardIconFill from "@material-symbols/svg-400/outlined/keyboard-fill.svg?react";
import { themeColor } from "../Themes/ThemeFunctions";
import { ThemeColorEnum, ThemeIconEnum, ThemeIconSizeEnum } from "../Themes/ThemeEnums";
import React from "react";

const Div = styled.div<{ theme: ITheme; $color: ThemeColorEnum; $size: number }>`
  width: ${(props) => props.$size}px;
  height: ${(props) => props.$size}px;
  flex-shrink: 0;

  & > svg {
    width: 100%;
    height: 100%;
  }

  ${(props) => {
    const color = themeColor(props.$color, props.theme);
    if (color) {
      return css`
        fill: ${color};
      `;
    }
  }};
`;

interface IconProps {
  icon: ThemeIconEnum;
  color: ThemeColorEnum;
  filled?: boolean;
  size?: ThemeIconSizeEnum;
}

const Icon: React.FC<IconProps> = ({ icon, color, filled, size = ThemeIconSizeEnum.SMALL }) => {
  return (
    <Div $color={color} $size={size}>
      {(() => {
        switch (icon) {
          case ThemeIconEnum.MENU:
            return filled ? <MenuIconFill /> : <MenuIcon />;
          case ThemeIconEnum.MORE_VERT:
            return filled ? <MoreVertIconFill /> : <MoreVertIcon />;
          case ThemeIconEnum.SETTINGS:
            return filled ? <SettingsIconFill /> : <SettingsIcon />;
          case ThemeIconEnum.PERSON:
            return filled ? <PersonIconFill /> : <PersonIcon />;
          case ThemeIconEnum.SPORTS_ESPORTS:
            return filled ? <SportsEsportsIconFill /> : <SportsEsportsIcon />;
          case ThemeIconEnum.HISTORY:
            return filled ? <HistoryIconFill /> : <HistoryIcon />;
          case ThemeIconEnum.ADD:
            return filled ? <AddIconFill /> : <AddIcon />;
          case ThemeIconEnum.APPS:
            return filled ? <AppsIconFill /> : <AppsIcon />;
          case ThemeIconEnum.ARROW_BACK:
            return filled ? <ArrowBackIconFill /> : <ArrowBackIcon />;
          case ThemeIconEnum.SYNC:
            return filled ? <SyncIconFill /> : <SyncIcon />;
          case ThemeIconEnum.PALLETE:
            return filled ? <PaletteIconFill /> : <PaletteIcon />;
          case ThemeIconEnum.NAVIGATION:
            return filled ? <NavigationIconFill /> : <NavigationIcon />;
          case ThemeIconEnum.HOME:
            return filled ? <HomeIconFill /> : <HomeIcon />;
          case ThemeIconEnum.DOWNLOAD:
            return filled ? <DownloadIconFill /> : <DownloadIcon />;
          case ThemeIconEnum.UPLOAD:
            return filled ? <UploadIconFill /> : <UploadIcon />;
          case ThemeIconEnum.FULLSCREEN:
            return filled ? <FullscreenIconFill /> : <FullscreenIcon />;
          case ThemeIconEnum.OPEN_IN_FULL:
            return filled ? <OpenInFullIconFill /> : <OpenInFullIcon />;
          case ThemeIconEnum.CLOSE_FULLSCREEN:
            return filled ? <CloseFullscreenIconFill /> : <CloseFullscreenIcon />;
          case ThemeIconEnum.LOCAL_BAR:
            return filled ? <LocalBarIconFill /> : <LocalBarIcon />;
          case ThemeIconEnum.LOGOUT:
            return filled ? <LogoutIconFill /> : <LogoutIcon />;
          case ThemeIconEnum.RESTAURANT:
            return filled ? <RestaurantIconFill /> : <RestaurantIcon />;
          case ThemeIconEnum.SPORTS_BAR:
            return filled ? <SportsBarIconFill /> : <SportsBarIcon />;
          case ThemeIconEnum.CLOSE:
            return filled ? <CloseIconFill /> : <CloseIcon />;
          case ThemeIconEnum.CLOUD_OFF:
            return filled ? <CloudOffIconFill /> : <CloudOffIcon />;
          case ThemeIconEnum.CHECK:
            return filled ? <CheckIconFill /> : <CheckIcon />;
          case ThemeIconEnum.ARROW_FORWARD:
            return filled ? <ArrowForwardIconFill /> : <ArrowForwardIcon />;
          case ThemeIconEnum.ERROR:
            return filled ? <ErrorIconFill /> : <ErrorIcon />;
          case ThemeIconEnum.WARNING:
            return filled ? <WarningIconFill /> : <WarningIcon />;
          case ThemeIconEnum.WAREHOUSE:
            return filled ? <WarehouseIconFill /> : <WarehouseIcon />;
          case ThemeIconEnum.PUBLISH:
            return filled ? <PublishIconFill /> : <PublishIcon />;
          case ThemeIconEnum.BUILD:
            return filled ? <BuildIconFill /> : <BuildIcon />;
          case ThemeIconEnum.DATABASE:
            return filled ? <DatabaseIconFill /> : <DatabaseIcon />;
          case ThemeIconEnum.GROUPS:
            return filled ? <GroupsIconFill /> : <GroupsIcon />;
          case ThemeIconEnum.MAP:
            return filled ? <MapIconFill /> : <MapIcon />;
          case ThemeIconEnum.SCHEDULE:
            return filled ? <ScheduleIconFill /> : <ScheduleIcon />;
          case ThemeIconEnum.PLAY_CIRCLE:
            return filled ? <PlayCircleIconFill /> : <PlayCircleIcon />;
          case ThemeIconEnum.PRINT:
            return filled ? <PrintIconFill /> : <PrintIcon />;
          case ThemeIconEnum.CALENDAR_MONTH:
            return filled ? <CalendarMonthIconFill /> : <CalendarMonthIcon />;
          case ThemeIconEnum.CHEVRON_LEFT:
            return filled ? <ChevronLeftIconFill /> : <ChevronLeftIcon />;
          case ThemeIconEnum.CHEVRON_RIGHT:
            return filled ? <ChevronRightIconFill /> : <ChevronRightIcon />;
          case ThemeIconEnum.ARROW_DROP_DOWN:
            return filled ? <ArrowDropDownIconFill /> : <ArrowDropDownIcon />;
          case ThemeIconEnum.KEYBOARD:
            return filled ? <KeyboardIconFill /> : <KeyboardIcon />;
          default:
            return null;
        }
      })()}
    </Div>
  );
};

export default Icon;
